import { useSetAtom } from 'jotai';
import { getCountryCallingCode, getExampleNumber, AsYouType } from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';
import React__default, { useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import '../../../rev/layouts/Alignment/alignment.scss';
import '../../../rev/layouts/Box.js';
import { Group } from '../../../rev/layouts/Group.js';
import '../../../rev/layouts/Section.js';
import '../../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../../rev/layouts/Stack.js';
import '../../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../../rev/atoms/Button.js';
import { Callout } from '../../../rev/atoms/Callout.js';
import '../../../rev/atoms/Card.scss';
import '../../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../../rev/atoms/CheckboxGroup.scss';
import '../../../rev/atoms/Tag.scss';
import '../../../rev/atoms/Chip.scss';
import '../../../rev/atoms/DateInput.js';
import { Text } from '../../../rev/atoms/Text.js';
import '../../../rev/atoms/Divider.scss';
import '../../../rev/atoms/Spinner.scss';
import '../../../rev/atoms/Dropzone.scss';
import '../../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../../rev/molecules/RichDescription.js';
import '../../../rev/molecules/TitleGroup.scss';
import '../../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../../rev/atoms/LabelledList.scss';
import '../../../rev/atoms/LabelPrice.scss';
import '../../../rev/atoms/Link.scss';
import '../../../rev/atoms/ListViewGroup.scss';
import '../../../rev/atoms/ListViewRow.scss';
import '../../../rev/atoms/Note.scss';
import '../../../rev/atoms/OldTextInput.js';
import '../../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../../rev/atoms/SegmentedControl.scss';
import '../../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../../rev/molecules/Tooltip/Tooltip.js';
import '../../../rev/atoms/Slider.scss';
import '../../../rev/atoms/SteppedProgressBar.scss';
import '../../../rev/atoms/Switch.js';
import '../../../rev/atoms/Tabs.scss';
import '../../../rev/atoms/TextArea.js';
import { TextInput } from '../../../rev/atoms/TextInput.js';
import '../../../rev/atoms/TimeInput.js';
import '../../../rev/atoms/ToggleButton.js';
import '../../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../../rev/molecules/Accordion.scss';
import '../../../rev/molecules/ActionMenu.scss';
import '../../../rev/molecules/BankInfo/BankInfo.scss';
import '../../../rev/molecules/Carousel.scss';
import '../../../rev/molecules/ContentSlider.js';
import '../../../rev/molecules/Drawer.js';
import { Dropdown } from '../../../rev/molecules/Dropdown.js';
import '../../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../../rev/molecules/Lightbox.scss';
import '../../../components/loadingAtoms.js';
import '../../../rev/molecules/LoadingPage.scss';
import '../../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../../utils/addressCache.js';
import '../../../rev/molecules/OldAddressInput.scss';
import '../../../rev/atoms/Button.scss';
import '../../../rev/molecules/OrderFooter.scss';
import '../../../rev/molecules/Pagination.scss';
import '../../../rev/molecules/Popover.js';
import '../../../rev/molecules/Popup.scss';
import '../../../rev/molecules/SearchInput.scss';
import '../../../rev/molecules/Sheet.js';
import '../../../rev/molecules/Table/Table.scss';
import '../../../rev/molecules/Toast.js';
import '../../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../../rev/organisms/AddressInput.js';
import '../../../rev/sections/CalculatePaymentModal.scss';
import '../../../rev/sections/ConfirmAddressModal.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import '../../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../../constants.js';
import '../../../rev/sections/FormModal/FormModal.scss';
import '../../../rev/sections/FormModal/types.js';
import 'moment';
import '../../../types/leads/Lead.js';
import '../../../rev/sections/LeadsSection/LeadCard.scss';
import { setMfaSmsCodeSentAtom } from '../../atoms/mfaSmsAtoms.js';
import { useSendSmsVerificationCode } from '../../hooks/useEnrollMfaSms.js';
import { useAuthContext } from '../../providers/AuthContext.js';
import { FIREBASE_SUPPORTED_COUNTRIES } from '../../services/mfaSmsService.js';
import { AuthHeader } from '../common/AuthHeader.js';

// Use browser's Intl API to get localized country names - no external package needed
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
/**
 * Get country name from ISO 3166-1 alpha-2 code using browser's Intl API
 */
function getCountryName(countryCode) {
    try {
        return regionNames.of(countryCode) ?? countryCode;
    }
    catch {
        return countryCode;
    }
}
// Priority countries to show at top of dropdown list
const PRIORITY_COUNTRIES = ['US', 'GB'];
/**
 * Get phone number mask and digit count for a country using libphonenumber-js
 */
function getPhoneFormatInfo(countryCode) {
    try {
        const exampleNumber = getExampleNumber(countryCode, examples);
        if (exampleNumber) {
            const nationalNumber = exampleNumber.nationalNumber;
            const digitCount = nationalNumber.length;
            // Use AsYouType to get the formatting template
            const formatter = new AsYouType(countryCode);
            formatter.input(nationalNumber);
            const template = formatter.getTemplate();
            if (template) {
                // Convert 'x' placeholders to '_' for our mask format
                const mask = template.replace(/x/g, '_');
                return { mask, digitCount };
            }
        }
    }
    catch {
        // Fall back to simple mask if example number not available
    }
    // Fallback: simple mask based on typical phone number length
    return { mask: '__________', digitCount: 10 };
}
/**
 * Build country options list with formatting info from libphonenumber-js
 * Only includes Firebase-supported countries for phone auth
 */
function buildCountryOptions(firebaseSupportedCountries) {
    const options = firebaseSupportedCountries.map((code) => {
        const callingCode = getCountryCallingCode(code);
        const { mask, digitCount } = getPhoneFormatInfo(code);
        const name = getCountryName(code);
        return {
            countryCode: code,
            callingCode: `+${callingCode}`,
            name,
            mask,
            digitCount,
        };
    });
    // Sort: priority countries first, then alphabetically by name
    return options.sort((a, b) => {
        const aPriority = PRIORITY_COUNTRIES.indexOf(a.countryCode);
        const bPriority = PRIORITY_COUNTRIES.indexOf(b.countryCode);
        if (aPriority !== -1 && bPriority !== -1) {
            return aPriority - bPriority;
        }
        if (aPriority !== -1)
            return -1;
        if (bPriority !== -1)
            return 1;
        return a.name.localeCompare(b.name);
    });
}
const DEFAULT_COUNTRY_CODE = 'US';
const recaptchaContainerId = 'recaptcha-container-sms-phone';
/**
 * Phone number input step for SMS MFA enrollment
 * Handles phone number validation and sending verification code
 */
function MfaSmsPhoneInput({ onRequiresRecentLogin, checkRequiresRecentLogin, }) {
    const { mfaSmsService } = useAuthContext();
    const setCodeSent = useSetAtom(setMfaSmsCodeSentAtom);
    const recaptchaVerifierRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const { mutate: sendVerificationCode, isPending: isSendingCode, error: sendCodeError, reset: resetSendCodeMutation, } = useSendSmsVerificationCode();
    // Build country options from FIREBASE_SUPPORTED_COUNTRIES
    const COUNTRY_OPTIONS = useMemo(() => buildCountryOptions(FIREBASE_SUPPORTED_COUNTRIES), []);
    const { control, handleSubmit, getValues, watch, trigger, formState: { errors, isSubmitting, isValid }, } = useForm({
        mode: 'onChange',
        defaultValues: {
            countryCode: DEFAULT_COUNTRY_CODE,
            phoneNumber: '',
        },
    });
    const selectedCountryCode = watch('countryCode');
    const selectedCountry = useMemo(() => COUNTRY_OPTIONS.find((c) => c.countryCode === selectedCountryCode) ??
        COUNTRY_OPTIONS[0], [selectedCountryCode, COUNTRY_OPTIONS]);
    // Re-validate phone number when country changes to ensure digit count matches
    useEffect(() => {
        const phoneNumber = getValues('phoneNumber');
        // Only re-validate if user has already entered a phone number
        if (phoneNumber) {
            trigger('phoneNumber');
        }
    }, [selectedCountryCode, getValues, trigger]);
    // Initialize reCAPTCHA verifier on mount
    useEffect(() => {
        if (!recaptchaVerifierRef.current) {
            try {
                recaptchaVerifierRef.current =
                    mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
            }
            catch (error) {
                console.error('Failed to initialize reCAPTCHA:', error);
                setErrorMessage('Failed to initialize verification. Please refresh the page.');
            }
        }
        // Cleanup reCAPTCHA on unmount
        return () => {
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                }
                catch (error) {
                    // Ignore cleanup errors
                    console.error('Error clearing reCAPTCHA:', error);
                }
                recaptchaVerifierRef.current = null;
            }
        };
    }, [mfaSmsService]);
    // Create retry callback for reauth flow
    const createRetryCallback = useCallback(() => {
        return () => {
            // Reset reCAPTCHA before retrying
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                    recaptchaVerifierRef.current =
                        mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
                }
                catch (clearError) {
                    console.error('Failed to reset reCAPTCHA:', clearError);
                }
            }
            // Reset mutation state
            resetSendCodeMutation();
            // Get the current phone number and retry
            const countryCode = getValues('countryCode');
            const country = COUNTRY_OPTIONS.find((c) => c.countryCode === countryCode);
            const callingCode = country?.callingCode ?? '+1';
            const phoneNumber = getValues('phoneNumber');
            const phoneDigits = phoneNumber.replace(/\D/g, '');
            const fullPhoneNumber = `${callingCode}${phoneDigits}`;
            if (phoneNumber && recaptchaVerifierRef.current) {
                setErrorMessage(null);
                sendVerificationCode({
                    phoneNumber: fullPhoneNumber,
                    recaptchaVerifier: recaptchaVerifierRef.current,
                }, {
                    onSuccess: (id) => {
                        setCodeSent({ verificationId: id, phoneNumber: fullPhoneNumber });
                    },
                });
            }
        };
    }, [
        getValues,
        resetSendCodeMutation,
        sendVerificationCode,
        setCodeSent,
        mfaSmsService,
        COUNTRY_OPTIONS,
    ]);
    // Update error message when mutation has errors
    useEffect(() => {
        if (sendCodeError) {
            // Handle requires-recent-login by showing reauth popup via parent
            if (checkRequiresRecentLogin(sendCodeError)) {
                onRequiresRecentLogin(createRetryCallback());
                return;
            }
            setErrorMessage(sendCodeError.message);
            // Reset reCAPTCHA on error so user can try again
            if (recaptchaVerifierRef.current) {
                try {
                    recaptchaVerifierRef.current.clear();
                    recaptchaVerifierRef.current =
                        mfaSmsService.createRecaptchaVerifier(recaptchaContainerId);
                }
                catch (clearError) {
                    console.error('Failed to reset reCAPTCHA:', clearError);
                }
            }
        }
    }, [
        sendCodeError,
        checkRequiresRecentLogin,
        onRequiresRecentLogin,
        createRetryCallback,
        mfaSmsService,
    ]);
    const submitHandler = handleSubmit((data) => {
        if (!recaptchaVerifierRef.current) {
            setErrorMessage('Verification not initialized. Please refresh the page.');
            return;
        }
        setErrorMessage(null);
        // Combine country calling code with phone number digits for E.164 format
        const country = COUNTRY_OPTIONS.find((c) => c.countryCode === data.countryCode);
        const callingCode = country?.callingCode ?? '+1';
        const phoneDigits = data.phoneNumber.replace(/\D/g, '');
        const fullPhoneNumber = `${callingCode}${phoneDigits}`;
        sendVerificationCode({
            phoneNumber: fullPhoneNumber,
            recaptchaVerifier: recaptchaVerifierRef.current,
        }, {
            onSuccess: (id) => {
                setCodeSent({ verificationId: id, phoneNumber: fullPhoneNumber });
            },
            onError: () => {
                // Error message is handled by useEffect
            },
        });
    });
    return (React__default.createElement(Stack, { itemsSpacing: '24' },
        React__default.createElement(AuthHeader, { title: 'SMS verification', details: 'Receive a one-time code by text message whenever you sign in.' }),
        errorMessage && (React__default.createElement(Callout, { title: 'Error', message: errorMessage, variant: 'error', appearance: 'filled' })),
        React__default.createElement("form", { onSubmit: submitHandler },
            React__default.createElement(Stack, { itemsSpacing: '24' },
                React__default.createElement(Stack, { itemsSpacing: '4' },
                    React__default.createElement(Text, { size: 'footnote' }, "Phone number"),
                    React__default.createElement(Group, { itemsSpacing: '8', itemsAlignX: 'start', itemsAlignY: 'start', noWrap: true },
                        React__default.createElement(Controller, { name: 'countryCode', control: control, render: ({ field: { onChange, value } }) => (React__default.createElement(Dropdown, { options: COUNTRY_OPTIONS.map((c) => ({
                                    id: c.countryCode,
                                    label: c.name,
                                    description: c.callingCode,
                                    selectedLabel: c.callingCode,
                                })), value: value, onSelectionChange: (val) => onChange(val), placeholder: selectedCountry.callingCode, size: 'xlarge', disabled: isSubmitting || isSendingCode })) }),
                        React__default.createElement(Group.Item, { grow: true },
                            React__default.createElement(Controller, { name: 'phoneNumber', control: control, rules: {
                                    required: 'Phone number is required',
                                    validate: (value) => {
                                        const cleaned = value.replace(/\D/g, '');
                                        const requiredDigits = selectedCountry.digitCount;
                                        if (cleaned.length < requiredDigits) {
                                            return `Please enter a valid ${requiredDigits}-digit phone number`;
                                        }
                                        // Additional validation using service
                                        const fullNumber = `${selectedCountry.callingCode}${cleaned}`;
                                        if (!mfaSmsService.validatePhoneNumber(fullNumber)) {
                                            return 'Please enter a valid phone number';
                                        }
                                        return true;
                                    },
                                }, render: ({ field: { onChange, onBlur, value } }) => (React__default.createElement(TextInput, { placeholder: 'Enter your phone number', value: value, onChange: (val) => onChange(val), onBlur: onBlur, type: 'text', mask: selectedCountry.mask, maskPlaceholderChar: '_', maskAllowedChars: /\d/, size: 'large', variant: 'outline', hasError: errors.phoneNumber?.message, isDisabled: isSubmitting || isSendingCode })) })))),
                React__default.createElement(Button, { size: 'large', isFullWidth: true, isLoading: isSubmitting || isSendingCode, isDisabled: !isValid || isSubmitting || isSendingCode, type: 'submit', onPress: () => submitHandler() }, "Send code"),
                React__default.createElement("div", { id: recaptchaContainerId })))));
}

export { MfaSmsPhoneInput };
//# sourceMappingURL=MfaSmsPhoneInput.js.map
